import { useState, useEffect, useCallback } from "react";
import { Form, Row, Col } from "react-bootstrap";
import "bootstrap-icons/font/bootstrap-icons.css";
import useApp from "../../AppContext";
import "./EntryWithBooking.css";
import { useNavigate } from "react-router-dom";
import EditBookingForm from "./EditTabletBooking";
import { loadListAllObjects, loadDataObject } from "../../Calendar/CalendarUtils";
import BarcodeReader from "../../crud/BarcodeReader";
import HomeIcon from '@mui/icons-material/Home';
import { format } from 'date-fns';
import PaginationControls from "../../Components/PaginationControls";
import { t } from "./../../i18n"
import { ErrorAlert } from '../../crud/utils';

function EntryWithBooking(props) {
    const navigate = useNavigate();
    const app = useApp();
    const [activeTab] = useState(1);
    const [language] = useState(app.sessionToken?.Language);
    const [actions, setActions] = useState("EditBoocking");
    const [selectTtimeSlot] = useState(new Date().toISOString());
    const [bookingId, setBookingId] = useState(null);
    const [error, setError] = useState(null);
    const [isHoliday] = useState(false);
    const [serverUrl] = useState(app.serverUrl);
    const [allColumnsObj, setAllColumnsObj] = useState({});
    const [data, setData] = useState({});
    // const [socialSecurityNo, setSocialSecurityNo] = useState(null);
    // const [supplierOnChange, setSupplierOnChange] = useState(null);
    const [socialSecurityNo, setSocialSecurityNo] = useState('');
    const [supplierOnChange, setSupplierOnChange] = useState('');
    const [matchingSuppliers, setMatchingSuppliers] = useState([]);
    const [dataLoaded, setDataLoaded] = useState(false);
    const [shouldFetchArrival, setShouldFetchArrival] = useState(false);
    const [showMatchingDropdown, setShowMatchingDropdown] = useState(false);
    const [hasSelectedSupplier, setHasSelectedSupplier] = useState(false);
    const [isManualSSNInput, setIsManualSSNInput] = useState(false);
    const [qrInput, setQrInput] = useState('');
    const [showBarcodeReader, setShowBarcodeReader] = useState(false);
    const [disabledFieldsFlg, setDisabledFieldsFlg] = useState(false);
    const [saveTriggered, setSaveTriggered] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 3;

    const totalPages = Math.ceil(matchingSuppliers.length / itemsPerPage);
    const paginatedSuppliers = matchingSuppliers.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );
    useEffect(() => {
        setCurrentPage(1);
    }, [matchingSuppliers]);

    const resetFormState = useCallback(() => {
        if (!bookingId) {
            setQrInput('');
            setSocialSecurityNo('');
            setSupplierOnChange('');
            setShowMatchingDropdown(false);
            setData({});
            setDataLoaded(false);
            setDisabledFieldsFlg(false);
        }
    }, [bookingId]);

    useEffect(() => {
        const fetchAllColumns = async () => {
            if (serverUrl && Object.keys(allColumnsObj).length === 0) {
                const allObj = await loadListAllObjects(serverUrl, props.userToken);
                setAllColumnsObj(allObj);
            }
        };
        fetchAllColumns();
    }, [serverUrl, props.userToken, allColumnsObj]);

    useEffect(() => {
        const fetchArrivalData = async () => {
            if (!shouldFetchArrival || !qrInput || Object.keys(allColumnsObj).length === 0) return;

            const objectName = "Yms_Booking";
            const prms = [];
            const prmValues = {};
            const defaultVariables = {
                filterName: "customfilter",
                appendFilter: "ARRIVALID = ?(;n;12;p_ArrivalId) AND Status = 5",
            };

            if (app.sessionToken?.Role === 'DoorUser') {
                prms.push({ parameterName: "p_ArrivalId", type: "int" });
                prmValues["p_ArrivalId"] = qrInput;
            }

            try {
                const responseObj = await loadDataObject(
                    serverUrl,
                    props.userToken,
                    objectName,
                    allColumnsObj,
                    prms,
                    prmValues,
                    defaultVariables
                );

                if (!responseObj || responseObj.length === 0) {
                    setError(t('tablet.qrNotActiveOrNotExist', language));
                    resetFormState();
                    setDataLoaded(false);
                    return;
                }

                const booking = responseObj[0];
                // console.log("booking", responseObj);
                if (booking && booking.Status === 5) {
                    setData({ [objectName]: [booking] });
                    setBookingId(booking.BookingId);
                    setDisabledFieldsFlg(true);
                    setDataLoaded(true);
                    setError(null);
                } else {
                    resetFormState();
                    setDataLoaded(false);
                }
            } catch (error) {
                console.error("Error fetching arrival data:", error);
                resetFormState();
                setDataLoaded(false);
            } finally {
                setShouldFetchArrival(false);
            }
        };

        fetchArrivalData();
    }, [shouldFetchArrival, qrInput, allColumnsObj, serverUrl, app.sessionToken, props.userToken, resetFormState, language]);



    useEffect(() => {
        const fetchData3plOrSup = async () => {
            if (!socialSecurityNo || hasSelectedSupplier || Object.keys(allColumnsObj).length === 0) return;

            const today = format(new Date(), 'yyyy-MM-dd');
            const warehouseId = app.sessionToken.WarehouseId;
            const prmsSuppliers = [{ parameterName: "p_socialSecurityNo", type: "" }];
            const prmValuesSuppliers = { p_socialSecurityNo: socialSecurityNo };
            const filterSuppliers = `YmsSup1.SocialSecurityNo = ?(;n;12;p_socialSecurityNo)`;
            const suppliers = await loadDataObject(
                serverUrl,
                props.userToken,
                "Yms_BookingSuppliers",
                allColumnsObj,
                prmsSuppliers,
                prmValuesSuppliers,
                {
                    filterName: "customfilter",
                    appendFilter: filterSuppliers,
                }
            );
            if (!suppliers.length) {
                const today = format(new Date(), 'yyyy-MM-dd');
                const warehouseId = app.sessionToken.WarehouseId;

                const prmsBookings = [
                    { parameterName: "p_socialSecurityNo", type: "" },
                    { parameterName: "p_todayDate", type: "" },
                    { parameterName: "p_warehouseId", type: "" },
                ];

                const prmValuesBookings = {
                    p_socialSecurityNo: socialSecurityNo,
                    p_todayDate: today,
                    p_warehouseId: warehouseId,
                };

                const filterBookings = `
        Yms3pl1.SocialSecurityNo = ?(;n;12;p_socialSecurityNo) 
        AND TRUNC(FromDate) = TO_DATE(?(;s;10;p_todayDate), 'YYYY-MM-DD') 
        AND YMSBOK.WarehouseId = ?(;n;5;p_warehouseId)
        AND Status = 5
    `;

                const bookings = await loadDataObject(
                    serverUrl,
                    props.userToken,
                    "Yms_Booking",
                    allColumnsObj,
                    prmsBookings,
                    prmValuesBookings,
                    { filterName: "customfilter", appendFilter: filterBookings, top: 50 }
                );

                setMatchingSuppliers(bookings || []);
                if (isManualSSNInput) setShowMatchingDropdown(true);
                return;
            }

            const bookingIds = suppliers.map(s => s.BookingId);


            const prmsBookings = bookingIds.map((_, i) => ({
                parameterName: `p_bookingId${i}`,
                type: ""
            }));
            prmsBookings.push({ parameterName: "p_todayDate", type: "" });
            prmsBookings.push({ parameterName: "p_warehouseId", type: "" });

            const prmValuesBookings = {};
            bookingIds.forEach((id, i) => {
                prmValuesBookings[`p_bookingId${i}`] = id;
            });
            prmValuesBookings["p_todayDate"] = today;
            prmValuesBookings["p_warehouseId"] = warehouseId;

            const inClause = bookingIds.map((_, i) => `?(;n;12;p_bookingId${i})`).join(',');
            const filterBookings = `BookingId IN (${inClause}) AND TRUNC(FromDate) = TO_DATE(?(;s;10;p_todayDate), 'YYYY-MM-DD') AND YMSBOK.WarehouseId = ?(;n;5;p_warehouseId) AND Status = 5`

            const bookings = await loadDataObject(
                serverUrl,
                props.userToken,
                "Yms_Booking",
                allColumnsObj,
                prmsBookings,
                prmValuesBookings,
                { filterName: "customfilter", appendFilter: filterBookings, top: 50 }
            );


            setMatchingSuppliers(bookings);
            if (isManualSSNInput) setShowMatchingDropdown(true);
        };

        fetchData3plOrSup();
    }, [socialSecurityNo, hasSelectedSupplier, allColumnsObj, serverUrl, app.sessionToken, props.userToken, isManualSSNInput]);




    useEffect(() => {
        if (!dataLoaded || !data?.Yms_Booking?.length) return;

        const bookingItem = data.Yms_Booking[0];
        const bookingId = bookingItem?.BookingId ?? '0';
        const tmpsocialSecurityNo = bookingItem?.Yms3pl1?.SocialSecurityNo ?? '';

        if (bookingId === '0') {
            setActions('NewBoocking');
            setData({});
            resetFormState();

        } else {
            setActions('EditBoocking');
            setBookingId(bookingId);
            setSocialSecurityNo(tmpsocialSecurityNo);
            setIsManualSSNInput(false);
            setSupplierOnChange(bookingItem?.SupDescr);
        }
    }, [dataLoaded, data, resetFormState]);

    return (
        <>
            <ErrorAlert message={error} setMessage={setError} language={language} />
            <div className="container my-5 tablet-container">
                <div className="mb-3">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">
                                <button onClick={() => navigate('/tablet-view')}><HomeIcon fontSize="small" style={{ marginBottom: '5px' }} /> {t("tablet.home", language)}</button>
                            </li>
                            <li className="breadcrumb-item active" aria-current="page">{t("tablet.entryWithBooking", language)}</li>
                        </ol>
                    </nav>
                </div>
                <h2 className="mb-4">{t("tablet.entryWithBooking", language)}</h2>
                <p className="subtitle-text">{t("entryWithBooking.subtitle", language)}</p>

                {showBarcodeReader && (
                    <BarcodeReader
                        onScan={(scannedValue) => {
                            setQrInput(scannedValue);
                            if (scannedValue && scannedValue !== '') {
                                setDisabledFieldsFlg(true)
                            }
                            setShouldFetchArrival(true);
                            setShowBarcodeReader(false);
                        }}
                        onClose={() => setShowBarcodeReader(false)}
                    />
                )}

                <Row className="mb-3">
                    <Col md={7}>
                        <Form.Group>
                            <Form.Label>{t("entryWithBooking.qrLabel", language)}</Form.Label>
                            <Form.Control
                                type="search"
                                placeholder={t("entryWithBooking.qrPlaceholder", language)}
                                value={qrInput}
                                onChange={(e) => setQrInput(e.target.value)}
                                onKeyDown={(e) => {
                                    if (e.key === "Enter" || e.key === "Tab") {
                                        e.preventDefault();
                                        const value = qrInput.trim();
                                        if (value !== "") {
                                            setQrInput(value);
                                            setShouldFetchArrival(true);
                                        } else {
                                            if (!bookingId) resetFormState();
                                        }
                                    }
                                }}

                                disabled={disabledFieldsFlg}
                            />
                        </Form.Group>
                    </Col>
                    <Col md={5} className="d-flex align-items-end">
                        <button
                            type="button"
                            className="btn btn-tablet-color w-100"
                            onClick={() => setShowBarcodeReader(true)}
                            disabled={disabledFieldsFlg}
                        >
                            <i className="bi bi-qr-code-scan me-2"></i> {t("entryWithBooking.scanQrButton", language)}
                        </button>
                    </Col>
                </Row>

                <Form.Group className="mb-3">
                    <Form.Label>{t("entryWithBooking.supplierLabel", language)}</Form.Label>
                    <Form.Control
                        type="search"
                        placeholder={t("entryWithBooking.supplierPlaceholder", language)}
                        value={supplierOnChange}
                        onChange={(e) => {
                            setIsManualSSNInput(true);
                            setSupplierOnChange(e.target.value);
                        }}
                        onKeyDown={(e) => {
                            if (e.key === "Enter" || e.key === "Tab") {
                                const value = supplierOnChange.trim();
                                if (value) {
                                    setHasSelectedSupplier(false);
                                    setSocialSecurityNo(value);
                                } else {
                                    if (!bookingId) resetFormState();
                                }
                            }
                        }}
                        disabled={disabledFieldsFlg}
                    />

                    {matchingSuppliers.length > 0 && showMatchingDropdown && !disabledFieldsFlg && (
                        <>
                            <div className="mt-2 mb-2 border rounded p-2" style={{ backgroundColor: app.theme === 'dark' ? '#3a3d40' : '#f8f9fa' }}>
                                <h5 style={{ color: app.theme === 'dark' ? 'var(--text-secondary)' : 'inherit' }}>{t("entryWithBooking.availableBookings", language)}</h5>
                                {paginatedSuppliers.map((item, idx) => (
                                    <div
                                        key={idx}
                                        onClick={() => {
                                            setBookingId(item?.BookingId);
                                            setQrInput(item?.ArrivalId || '');
                                            setActions("EditBoocking");
                                            setMatchingSuppliers([]);
                                            setShowMatchingDropdown(false);
                                            setHasSelectedSupplier(true);
                                            setCurrentPage(1);
                                            setSupplierOnChange(item?.SupDescr || '');
                                            setDisabledFieldsFlg(true);
                                        }}
                                        className="p-2 mb-1 rounded border shadow-sm cursor-pointer"
                                        style={{
                                            backgroundColor: app.theme === 'dark' ? 'var(--bg-tertiary)' : '#fff',
                                            color: app.theme === 'dark' ? 'var(--text-secondary)' : 'inherit',
                                            borderColor: app.theme === 'dark' ? '#495057' : '#dee2e6'
                                        }}
                                    >
                                        <div><strong>{t("entryWithBooking.warehouse", language)}:</strong> {item?.YmsWrh1.Descr1}</div>
                                        <div><strong>{t("entryWithBooking.bookingId", language)}:</strong> {item?.BookingId}</div>
                                        {item?.ArrivalId && <div><strong>Arrival ID:</strong> {item.ArrivalId}</div>}
                                        <div><strong>{t("ModalBooking.supplierTitleForm", language)}:</strong> {item?.SupDescr}</div>
                                        <div><strong>{t("ModalBooking.licenseNoTitleForm", language)}:</strong> {item?.YmsTrk1.LicenseNo}</div>
                                        <div><strong>{t("ModalBooking.driverTitleForm", language)}:</strong> {item?.YmsDri1.Name1}</div>
                                    </div>
                                ))}
                            </div>
                            <PaginationControls
                                currentPage={currentPage}
                                totalPages={totalPages}
                                onPageChange={(newPage) => setCurrentPage(newPage)}
                            /></>
                    )}

                </Form.Group>

                <EditBookingForm
                    saveTriggered={saveTriggered}
                    disabledFieldsFlg={disabledFieldsFlg}
                    activeTab={activeTab}
                    actions={actions}
                    setActions={setActions}
                    setQrInput={setQrInput}
                    bookingId={bookingId}
                    setBookingId={setBookingId}
                    setDisabledFieldsFlg={setDisabledFieldsFlg}
                    setSocialSecurityNo={setSupplierOnChange}
                    resetFormState={resetFormState}
                    warehouseid={app.sessionToken.WarehouseId}
                    selectTtimeSlot={selectTtimeSlot}
                    isHoliday={isHoliday}
                    userToken={props.userToken}
                />


            </div>
            <div className="tablet-btn-fixed-bottom">
                <button type="submit" className="btn btn-tablet-color" onClick={() => setSaveTriggered(prev => prev + 1)} disabled={bookingId === null || isNaN(bookingId)}>
                    {t("common.registration", language)}
                </button>
            </div>
        </>
    );
}

export default EntryWithBooking;
